/**
 * Op inversion (W1-03 core-model-ops; ARCHITECTURE.md §5.2).
 *
 * ins <-> del (both carry the full record), set / single swap prev and next, order swaps the lists. An idSeq op is
 * its own inverse: ids are never reused, so undo never lowers the counter (apply only ever raises it).
 */

import type { DelOp, InsOp, Op, SetOp, SingleOp } from './types';

export function invertOp(op: Op): Op {
  switch (op.o) {
    case 'ins':
      return { o: 'del', tbl: op.tbl, rec: op.rec } as DelOp;
    case 'del':
      return { o: 'ins', tbl: op.tbl, rec: op.rec } as InsOp;
    case 'set':
      return { o: 'set', tbl: op.tbl, id: op.id, prev: op.next, next: op.prev } as SetOp;
    case 'single':
      return { o: 'single', key: op.key, prev: op.next, next: op.prev } as SingleOp;
    case 'order':
      return { o: 'order', list: op.list, prev: op.next, next: op.prev };
    case 'idSeq':
      return op;
  }
}

/** Inverse of a sequence: inverted ops in reverse order. */
export function invertOps(ops: readonly Op[]): Op[] {
  const out: Op[] = new Array<Op>(ops.length);
  for (let i = 0; i < ops.length; i++) out[ops.length - 1 - i] = invertOp(ops[i] as Op);
  return out;
}
